import api from "../../../api/api";

/** OAuth: authorization URL, state, expires_at (company CorpPass) */
export const getInitialIras = (uen) =>
  api.get("/iras/initial-iras", { params: { uen } });

/** OAuth: authorization URL, state, expires_at (tax agent CorpPass) */
export const getInitialIrasTaxAgent = (uen) =>
  api.get("/iras/initial-iras-tax-agent", { params: { uen } });

/** OAuth: exchange CorpPass code for stored token */
export const exchangeIrasToken = (body) =>
  api.post("/iras/exchange-token", body);

/** Disconnect the organization's stored CorpPass connection */
export const disconnectIras = () => api.post("/iras/disconnect");
